import ManagedAccount from "@tootsweet/model/entities/ManagedAccount";
import { tt } from "../../utils/i18n/i18n";

export const getAccountDisplayName = (
  account: ManagedAccount | undefined,
  idx: number
): string => {
  if (!account) {
    return tt("select_account");
  }

  if (account.isAll) {
    return tt("all_accounts");
  }

  return account.placeName || `${tt("jp_default_place_name")} ${idx + 1}`;
};
